<template>
  <div class="markup">
    <div class="markup__subtitle markup__subtitle_head">ТТ Формат Mobile Stories Banner</div>
    <div class="markup__h markup__h_3">
      Данное размещение может содержать от двух до пяти слайдов с картинками и текстом. Левая и правая стороны креатива (по 17% от ширины экрана) зарезервированы под элементы управления – переключение слайдов.
    </div>
    <br>
    <router-link to="/mobile/stories" target="_blank" class="link">Демо формата</router-link>
    <br><br>

    <div class="markup__h markup__h_2">
      <strong>Необходимые материалы для размещения:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>
        <div class="markup__h markup__h_3">
          <strong>Фон по количеству слайдов в креативе:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Формат: PSD / FIGMA / AI </li>
          <li>Соотношение сторон: рекомендуется 9:16</li>
          <li>
            <p>Размеры: рекомендуется от <strong>1080px : 1920px</strong></p>
            <div class="attention attention_warn">
              <p>При подготовке материалов необходимо учесть вариант отображения в горизонтальном режиме (landscape). В другом случае будет добавлено брендированное сообщение "Поверните ваш девайс вертикально".</p>
              <p>Также необходимо учитывать, что формат адаптивный как по ширине так и по высоте, т.к. объявление может показываться на устройствах с различными размерами экрана (смартфоны / планшеты).</p>
            </div>
          </li>
        </ul>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Опционально</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Сценарий (последовательность анимации, смены слайдов и т.д.)</li>
          <li>Описание интерактивных элементов (кликабельные элементы, кнопки и т.д.)</li>
          <li>При отсутствии макетов для сборки креатива необходимо предоставить тексты и изображения (PNG / JPG / PDF / EPS), логотип, фирменные шрифты, Brandbook (в том числе пожелания по цветовому оформлению)</li>
        </ul>
      </li>
    </ul>
    <br>
    <marked-zone-atention></marked-zone-atention>
  </div>
</template>

<script>
import markedZoneAtention from '@/components/documentation/markedZoneAtention.vue';

export default {
  name: 'mobileStoriesBanner',
  components: {
    markedZoneAtention,
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'

</style>
